export default __webpack_public_path__ + "static/media/supportUa.e5e896e8.jpg";